export default "__VITE_ASSET__BW5L_cJk__"